import React from "react";
import "./MessageCard.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { formatDate, formatHourFrenchLocale } from "Services/functions";
import { useRef } from "react";
import BtnRond from "Components/Boutons/BtnRond/btn-rond";
import { FaEllipsisH } from "react-icons/fa";
import { Menu } from "primereact/menu";
import axios from "axios";
import { updateMessages } from "Redux/Actions/messagesActions";
import neutralUser from "assets/neutralUser.png";

const MessagesContainer = (props) => {
  const menu = useRef(null);

  // Supprime un message
  const deleteMessage = () => {
    axios
      .delete(
        `${process.env.REACT_APP_BASE_URL_API}/messages/${props.messageDetails.id}`,
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        }
      )
      .then(() => {
        let tempConv = props.messages.currentConversation;
        tempConv.messages = props.messages.currentConversation.messages.filter(
          (message) => message.id != props.messageDetails.id
        );
        props.handleMessages({
          currentConversation: tempConv,
        });
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  return (
    <div
      className={
        props.messageDetails.user.id === props.auth.userConnected.id
          ? "message myMessages"
          : "message"
      }
    >
      <div className="message_top">
        <div className="message_top_left">
          <div className="message_top_left_name">
            <img
              src={
                props.messageDetails.user.imageUrl
                  ? props.messageDetails.user.imageUrl
                  : neutralUser
              }
            ></img>
            {props.messageDetails.user.id !== props.auth.userConnected.id &&
              props.messageDetails.user.firstname +
                " " +
                props.messageDetails.user.surname}
          </div>
          <div className="message_top_left_date">
            {/* Si le message est du jour, affiche l'heure. Sinon affiche la date */}
            {formatDate(new Date()) ===
            formatDate(new Date(props.messageDetails.createdAt))
              ? formatHourFrenchLocale(new Date(props.messageDetails.createdAt))
              : formatDate(new Date(props.messageDetails.createdAt))}
          </div>
        </div>
        {props.messageDetails.user.id === props.auth.userConnected.id && (
          <div className="message_top_right">
            <Menu
              appendTo={document.getElementById("app")}
              model={[
                {
                  label: "Supprimer",
                  command: () => {
                    deleteMessage();
                  },
                },
              ]}
              popup
              ref={menu}
              style={{ textAlign: "center" }}
            />
            <BtnRond btnAction={(event) => menu.current.toggle(event)}>
              <FaEllipsisH size={"1.5rem"} />
            </BtnRond>
          </div>
        )}
      </div>

      <div className="message_content">{props.messageDetails.content}</div>
    </div>
  );
};

MessagesContainer.propTypes = {
  auth: PropTypes.object,
  messages: PropTypes.object,
  messageDetails: PropTypes.object,
  handleMessages: PropTypes.func,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  messages: state.messages,
});
const mapDispatchToProps = (dispatch) => ({
  handleMessages: (value) => {
    dispatch(updateMessages(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(MessagesContainer);
